import { useEffect, useState } from "react";

export const useReferralId = () => {
	const [referralId, setReferralId] = useState<string | undefined>(undefined);
	const [couponId, setCouponId] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (typeof window === "undefined") return;

		const rewardful = (window as any)?.rewardful;
		if (typeof rewardful !== "function") return;

		rewardful("ready", () => {
			const referral = (window as any)?.Rewardful?.referral;
			if (referral?.length) {
				setReferralId(referral);
			}
			const coupon = (window as any)?.Rewardful?.coupon?.id;
			if (coupon?.length) {
				setCouponId(coupon);
			}
		});
	}, []);

	return { referralId, couponId };
};
